module.exports = __webpack_public_path__ + "static/img/7.cc036980.png";